const DeliverBlock = () => {
    return(
        <>
        <div className="deliverBlock">
        <div className="deliverInfo">
            <h1 className="deliverInfoH1">Deliver more inclusive care.</h1>
            <p className="deliverInfoP">Violet powers culturally competent care at scale.</p>
            <button className="deliverInfoButton">Power your team</button>
           <div className="svgGreenImgVector">
           <svg width="400" height="63" viewBox="0 0 400 63" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M398.749 45.2471C310.754 0.999997 233.69 64.7678 184.392 58.7434C135.095 52.7189 141.81 15.8731 154.28 10.2989C166.751 4.72478 177.904 27.226 163.685 45.2471C149.466 63.2682 120.642 69.0321 102.885 49.1951C83.9998 28.0968 84.4872 2.254 55.1676 9.48029C25.8479 16.7066 10.4794 13.9716 1 1" stroke="#134A45" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
           </div>
        </div>
        <div className="deliverImg">
          <div className="grandmotherImg"><img src=".\img\grandmother.png" alt="" /></div>  
          <div className="menImg"><img src=".\img\men.png" alt="" /></div>  
          <div className="grandfatherImg"><img src=".\img\grandfather.png" alt="" /></div>
        </div>
          <div className="svgGreenImgVector2">
            <svg width="82" height="90" viewBox="0 0 82 90" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 45C0 20.1472 20.1472 0 45 0C69.8528 0 90 20.1472 90 45C90 69.8528 69.8528 90 45 90C20.1472 90 0 69.8528 0 45Z" fill="#134A45"/>
            </svg>
          </div>
        </div>
       <div className="svgPinkImgVector">
            <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 25C0 11.1929 11.1929 0 25 0C38.8071 0 50 11.1929 50 25C50 38.8071 38.8071 50 25 50C11.1929 50 0 38.8071 0 25Z" fill="#B961CD"/>
            </svg>
       </div>
        </>
    );
}

export default DeliverBlock;